module.exports = __webpack_public_path__ + "static/img/7.d23a54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/7.png
// module id = ZUQc
// module chunks = 1